import API from "../../../../../global/api";
import _ from "lodash";



export const requestUploadAttendanceFile = () => {
    return {
        type: "REQUEST_UPLOAD_ATTENDANCE_FILE",
    };
};
export const successUploadAttendanceFile = (data) => {
    return {
        type: "SUCCESS_UPLOAD_ATTENDANCE_FILE",
        // payload: data
    };
};
export const errorUploadAttendanceFile = () => {
    return {
        type: "ERROR_UPLOAD_ATTENDANCE_FILE",
    };
};
export const UploadAttendanceFileApi = (data, showSuccessAlert, showErrorAlert) => {
    const formData = new FormData();
    formData.append("attendanceFile", _.get(data, "attendanceFile"));
    formData.append("attendanceMonthYear", `${data.attendanceMonthYear}`);

    return (dispatch) => {
        dispatch(requestUploadAttendanceFile());
        API.post(`/attendance/upload-attendance`, formData).then((res) => {
            let getData = res.data;
            dispatch(successUploadAttendanceFile(getData));
            showSuccessAlert(res.data.message);
        }).catch((error) => {
            dispatch(errorUploadAttendanceFile());
            showErrorAlert(error.response.data.message);
        });
    };
};


export const requestDeleteAttendance = () => {
    return {
        type: "REQUEST_DELETE_ATTENDANCE",
    };
};
export const successDeleteAttendance = (data) => {
    return {
        type: "SUCCESS_DELETE_ATTENDANCE",
        payload: data,
    };
};
export const errorDeleteAttendance = () => {
    return {
        type: "ERROR_DELETE_ATTENDANCE",
    };
};
export const DeleteAttendanceApi = (attendanceID, updateTableQuery) => {
    return (dispatch) => {
        dispatch(requestDeleteAttendance());
        API.delete(`/attendance/delete-attendance/${attendanceID}`).then((res) => {
            dispatch(successDeleteAttendance());
            updateTableQuery();
        }).catch((error) => {
            dispatch(errorDeleteAttendance());
        })
    };
};